module.exports = __webpack_public_path__ + "f992e74ad9ceb9d05208c7db1e3bffdb.pdf";